import React from 'react'
import { useEffect } from 'react'

const Logout = () => {

    const logout = () => {
        localStorage.clear();
        window.location.href = '/login';
    }

    useEffect(()=>{
        logout()
    },[])

  return (
    <div></div>
  )
}

export default Logout